/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `weekly` - tygodniowy
 * * `monthlyBudget` - budżet miesięczny
 * * `shortTermThing` - cel rzeczowy krótkoterminowy
 * * `longTermThing` - cel rzeczowy długoterminowy
 * * `life` - cel życiowy
 */
export type GoalLevelEnum = typeof GoalLevelEnum[keyof typeof GoalLevelEnum];


export const GoalLevelEnum = {
  weekly: 'weekly',
  monthlyBudget: 'monthlyBudget',
  shortTermThing: 'shortTermThing',
  longTermThing: 'longTermThing',
  life: 'life',
} as const;
